import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getFontWeight } from '../../helpers/utils';

const RadioElement = ({
  name,
  lexicon,
  font,
  is_required = false,
  value,
  onChange = () => {},
  disabled = false,
  list,
  attributes,
}) => {
  const [selected, setSelected] = useState(value || null);

  useEffect(() => {
    if (value) {
      const choice = list?.choices?.find(c => c.id === value || c.name === value);
      setSelected(choice?.id || null);
    } else {
      setSelected(null);
    }
  }, [value, list?.choices]);

  const handleChange = choice => {
    setSelected(choice.id);
    onChange(lexicon, choice.id);
  };

  const choices = list?.choices || [];

  const labelStyle = {
    color: attributes?.font?.color || font?.color,
    fontSize: attributes?.font?.size || font?.size,
    fontWeight: getFontWeight(attributes?.font?.style || font?.style),
    fontFamily: attributes?.font?.name || font?.name,
  };

  return (
    <RadioElementWrapper>
      {name && (
        <div className="radio-label mb-1" style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
          <span style={labelStyle}>{name}</span>
          {is_required && <span className="required-star">!</span>}
        </div>
      )}
      <div className="radio-list">
        {choices.map(choice => (
          <label
            key={choice.id}
            className={`radio-option${disabled ? ' radio-option--disabled' : ''}`}
            onClick={() => !disabled && handleChange(choice)}>
            <span className={`radio-circle${selected === choice.id ? ' radio-circle--selected' : ''}`} />
            <span className="radio-text" style={labelStyle}>{choice.name}</span>
          </label>
        ))}
      </div>
    </RadioElementWrapper>
  );
};

const RadioElementWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin-bottom: 16px;

  .radio-label {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 8px;

    span {
      font-family: 'Inter', sans-serif;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: #2a3348;
    }

  }

  .radio-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .radio-option {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    user-select: none;

    &--disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  .radio-circle {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid #959595;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    transition: border-color 0.15s ease;

    &--selected {
      border-color: #004145;

      &::after {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #004145;
      }
    }
  }

  .radio-text {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    line-height: 20px;
    color: #2a3348;
  }
`;

export default RadioElement;
